import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-库存管理",
  "use": "icon-库存管理-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-库存管理\"><path d=\"M919.2 355.2l-388-277.6c-11.2-8-26.4-8-36.8 0L104 355.2c-12.8 8.8-6.4 28.8 9.6 28.8H192v496c0 8.8 7.2 16 16 16h608c8.8 0 16-7.2 16-16V384h78.4c15.2 0 21.6-20 8.8-28.8zM448 768H320V640h128v128z m0-320h128v128H448V448z m256 320H576V640h128v128z\" fill=\"\" p-id=\"15681\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol